import React from "react";
import AtkvaedalistiByKjordaemi from "./components/AtkvaedalistiByKjordaemi";
import AtkvaedalistiByEmbaetti from "./components/AtkvaedalistiByEmbaetti";


export default function Urvinnslur() {
  return (
    <div>
      <AtkvaedalistiByEmbaetti />
      <AtkvaedalistiByKjordaemi />
    </div>
  );
}
